export default __webpack_public_path__ + "static/media/analysis4.27dc7eed.svg";